import React from 'react';
import { StyledPaginationSortByComponentDiv } from './index.styles';
import clsx from 'clsx';
import { SearchSummaryComponent } from '../searchResultsSummary';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { SortByFilterComponent } from '../sortByFilter';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';

export const PaginationSortByComponent: React.FC<{
  isMobileState: boolean;
  className: string;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  segmentId?: string;
  isLatLongAvailable?: boolean;
  isCorpCodeEntered?: boolean;
  destinationType?: string;
}> = ({
  isMobileState,
  className,
  setFetchCurrencyConversionFactors,
  segmentId,
  isLatLongAvailable,
  isCorpCodeEntered,
  destinationType,
}) => {
  const { isMapViewEnabled } = useConditionalSearchResultsRenderedDataSERP(renderedData);
  return (
    <StyledPaginationSortByComponentDiv className={clsx('container', className, isMapViewEnabled ? `m-0` : ``)}>
      <div
        className={clsx(
          'container',
          'row-2',
          isMobileState && 'd-flex',
          isMobileState && 'pagination-sort-by-row',
          isMapViewEnabled ? `pr-3` : `pr-0`
        )}
      >
        <SearchSummaryComponent />
        <SortByFilterComponent
          isMobileState={isMobileState}
          segmentId={segmentId}
          isLatLongAvailable={isLatLongAvailable}
          setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
          isCorpCodeEntered={isCorpCodeEntered}
          destinationType={destinationType}
        />
      </div>
    </StyledPaginationSortByComponentDiv>
  );
};
